import { useMutation, useQueryClient } from '@tanstack/react-query';
import { sellerServices } from '../services/seller.service';
import { toast } from 'react-hot-toast';

export const useUpdateSellerStatus = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: sellerServices.updateSellerStatus,
    onSuccess: (data, variables) => {
      toast.success('Seller status updated successfully');
      queryClient.invalidateQueries({ queryKey: ['seller', variables.sellerId] });
      queryClient.invalidateQueries({ queryKey: ['sellers'] });
    },
    onError: (error) => {
      toast.error(error?.response?.data?.message || 'Failed to update seller status');
    },
  });
};
